import { create } from "zustand";
import { produce } from "immer";
import { RouterStore, RouterStoreItem, RouterStoreItemKey } from "@/store/useRouter/types";
import getUID from "@/lib/uid";

const tag = "@/store/useRouter";

// zustand store for router management
export const useRouter = create<RouterStore>((set, get) => ({
    history: [],

    // navigate to a new router item
    go: async (item: Partial<RouterStoreItem>) => {
        const i: RouterStoreItem = {
            active: true,
            key: item.key || RouterStoreItemKey.HELLO_WORLD,
            uid: item.uid || getUID(),
            data: item.data || undefined
        };
        set(
            produce((state: RouterStore) => {
                if (state.history.length > 0) {
                    state.history[state.history.length - 1].active = false;
                }
                state.history.push(i);
            })
        );
    },

    // go back to the previous router item
    back: async () => {
        const r = get();
        if (r.history.length > 0) {
            set(
                produce((state: RouterStore) => {
                    state.history.splice(r.history.length - 1, 1);
                    state.history[state.history.length - 1].active = true;
                })
            );
        }
    },

    // clear the router history
    clear: async () => {
        set(
            produce((state: RouterStore) => {
                state.history = [];
            })
        );
    },

    // set data for a specific router item
    setData: async (uid: string, data: any) => {
        const r = get();
        const itemIndex = r.history.findIndex(item => item.uid === uid);
        if (itemIndex >= 0) {
            set(
                produce((state: RouterStore) => {
                    state.history[itemIndex].data = data;
                })
            );
        }
    }

}));

if (process.env.NODE_ENV === "development") {
    if (!(window as any).web) {
        (window as any).web = {};
    }
    (window as any).web.useRouter = useRouter;
}

export default useRouter;